import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  FDBox,
  FDContentContainer,
  FDSecondaryActionButton,
} from '@facet-wealth/design';
import { useRightColumnContext } from 'Context/RightColumnContext';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';
import useUserContext from 'Context/UserContext';
import ScenarioQuestionPicker
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioQuestionPicker';
import {
  ScenarioSelectionRedefinedHeaderMobile,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioSelectionRedefinedWrapperHeader/ScenarioSelectionRedefinedHeaderMobile';
import {
  ScenarioSelectionRedefinedHeaderDesktop,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioSelectionRedefinedWrapperHeader/ScenarioSelectionRedefinedHeaderDesktop';
import { noop } from 'Helpers/PropTypes';


const ScenarioSelectionRedefinedWrapperHeader = ({
  resource,
  onAgentViewAllScenarios,
}) => {
  const { loadPageContentLink } = usePageContentContext();
  const { loadRightColumnCollectionLink, rightColumnCollectionLoading } = useRightColumnContext();

  const isMobile = useMobileLayout();
  const { isAgent } = useUserContext();

  const ViewAllScenariosButton = resource.withRelationship(fr.relationships.facetPlanProposalScenarioSelectionIntroPage.name, (rel) => {
    const onViewAllScenariosClick = async () => {
      if (isAgent) {
        await onAgentViewAllScenarios(resource);
        return;
      }
      loadPageContentLink(rel.link('related'));
    };

    if (rel.meta('icon')) {
      return (<FDSecondaryActionButton
        label={rel.meta('prompt')}
        size={'sm'}
        icon={rel.meta('icon')}
        onClick={onViewAllScenariosClick}
        {...dataAttrs('view-all-scenarios-button')}
      />);
    }

    return (
      <FDSecondaryActionButton
        label={rel.meta('prompt')}
        size={'sm'}
        onClick={onViewAllScenariosClick}
        {...dataAttrs('view-all-scenarios-button')}
      />
    );
  },
  () => null);

  const ScenarioQuestionForPlannerButton = resource.withRelationship(fr.relationships.scenarioQuestionForPlanner.name, (rel) => {
    return (
      <FDSecondaryActionButton
        label={rel.meta('prompt')}
        size={'sm'}
        icon={'chatBubbleOutline'}
        loading={rightColumnCollectionLoading ?? false}
        onClick={() => {
          loadRightColumnCollectionLink(rel.link('related'));
        }}
        disabled={isAgent}
        {...dataAttrs('ask-my-planner-button')}
      />
    );
  },
  () => null);

  const Component = isMobile ? ScenarioSelectionRedefinedHeaderMobile : ScenarioSelectionRedefinedHeaderDesktop;

  return (
    <FDContentContainer maxWidth={'xl'}>
      <FDBox paddingY={4}>
        <Component resource={resource}>
          {ViewAllScenariosButton}
          {ScenarioQuestionForPlannerButton}
        </Component>
      </FDBox>
      <ScenarioQuestionPicker />
    </FDContentContainer>
  );
};

ScenarioSelectionRedefinedWrapperHeader.defaultProps = {
  onAgentViewAllScenarios: noop,
};

ScenarioSelectionRedefinedWrapperHeader.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  onAgentViewAllScenarios: PropTypes.func,
};

export default ScenarioSelectionRedefinedWrapperHeader;
